import styled from "styled-components";

const BlankScreenStyled = styled.div`
    width: 100%
    height: 50rem;
    background: white
`;

export default BlankScreenStyled;
